import request from '@/utils/request';

// APP功能菜单
export const appMenuApi = {
  list:   ()           => request.get('/pm/app-menu'),
  create: (data)       => request.post('/pm/app-menu', data),
  update: (id, data)   => request.put(`/pm/app-menu/${id}`, data),
  remove: (id)         => request.delete(`/pm/app-menu/${id}`),
  toggle: (id)         => request.patch(`/pm/app-menu/${id}/toggle`)
};

// OA增值服务
export const valueServiceApi = {
  page:   (params)     => request.get('/pm/oa/value-service', { params }),
  create: (data)       => request.post('/pm/oa/value-service', data),
  update: (id, data)   => request.put(`/pm/oa/value-service/${id}`, data),
  remove: (id)         => request.delete(`/pm/oa/value-service/${id}`)
};

// 表单模板
export const formTemplateApi = {
  page:    (params)    => request.get('/pm/oa/form-template', { params }),
  detail:  (id)        => request.get(`/pm/oa/form-template/${id}`),
  create:  (data)      => request.post('/pm/oa/form-template', data),
  update:  (id, data)  => request.put(`/pm/oa/form-template/${id}`, data),
  remove:  (id)        => request.delete(`/pm/oa/form-template/${id}`),
  publish: (id)        => request.post(`/pm/oa/form-template/${id}/publish`)
};

// 招商管理（业绩/汇报）
export const salesApi = {
  performance: (params) => request.get('/pm/sales/performance', { params }),
  addPerf:     (data)   => request.post('/pm/sales/performance', data),
  reports:     (params) => request.get('/pm/sales/report', { params }),
  addReport:   (data)   => request.post('/pm/sales/report', data),
  updateReport:(id,data)=> request.put(`/pm/sales/report/${id}`, data),
  submitReport:(id)     => request.post(`/pm/sales/report/${id}/submit`),
  approveReport:(id, remark) => request.post(`/pm/sales/report/${id}/approve`, null, { params: { remark } }),
  rejectReport:(id, remark) => request.post(`/pm/sales/report/${id}/reject`, null, { params: { remark } })
};

// 服务合同
export const serviceContractApi = {
  page:      (params)    => request.get('/pm/service-contract', { params }),
  create:    (data)      => request.post('/pm/service-contract', data),
  update:    (id, data)  => request.put(`/pm/service-contract/${id}`, data),
  remove:    (id)        => request.delete(`/pm/service-contract/${id}`),
  approve:   (id)        => request.post(`/pm/service-contract/${id}/approve`),
  submit:    (id)        => request.post(`/pm/service-contract/${id}/submit`),
  terminate: (id)        => request.post(`/pm/service-contract/${id}/terminate`),
  renew:     (id, data)  => request.post(`/pm/service-contract/${id}/renew`, data || {})
};

// 代收代扣
export const bankCollectionApi = {
  page:    (params) => request.get('/pm/finance/bank-collection', { params }),
  create:  (data)   => request.post('/pm/finance/bank-collection', data),
  execute: (id)     => request.post(`/pm/finance/bank-collection/${id}/execute`),
  details: (id)     => request.get(`/pm/finance/bank-collection/${id}/details`)
};

// 短信设置
export const smsApi = {
  templates:     ()         => request.get('/pm/sms/template'),
  createTpl:     (data)     => request.post('/pm/sms/template', data),
  updateTpl:     (id, data) => request.put(`/pm/sms/template/${id}`, data),
  removeTpl:     (id)       => request.delete(`/pm/sms/template/${id}`),
  send:          (data)     => request.post('/pm/sms/send', data),
  logs:          (params)   => request.get('/pm/sms/log', { params }),
  getConfig:     ()         => request.get('/pm/sms/config'),
  saveConfig:    (data)     => request.put('/pm/sms/config', data),
  testSend:      (data)     => request.post('/pm/sms/config/test', data),
  refreshBalance:()         => request.post('/pm/sms/config/refresh-balance'),
  remindRules:   ()         => request.get('/pm/sms/remind-rule'),
  createRule:    (data)     => request.post('/pm/sms/remind-rule', data),
  updateRule:    (id, data) => request.put(`/pm/sms/remind-rule/${id}`, data),
  removeRule:    (id)       => request.delete(`/pm/sms/remind-rule/${id}`),
  remindSend:    (data)     => request.post('/pm/sms/remind-send', data || {}),
  stats:         (params)   => request.get('/pm/sms/stats', { params }),
  buildings:     ()         => request.get('/pm/sms/buildings')
};

export const remoteSupportApi = {
  page:   (params) => request.get('/pm/support/remote', { params }),
  create: (data)   => request.post('/pm/support/remote', data),
  reply:  (id, data) => request.put(`/pm/support/remote/${id}/reply`, data),
  close:  (id)     => request.put(`/pm/support/remote/${id}/close`)
};

// 日报
export const dailyReportApi = {
  page:     (params)    => request.get('/pm/daily-report', { params }),
  mine:     (params)    => request.get('/pm/daily-report/mine', { params }),
  detail:   (id)        => request.get(`/pm/daily-report/${id}`),
  create:   (data)      => request.post('/pm/daily-report', data),
  update:   (id, data)  => request.put(`/pm/daily-report/${id}`, data),
  comment:  (id, data)  => request.post(`/pm/daily-report/${id}/comment`, data),
  stats:    (params)    => request.get('/pm/daily-report/stats', { params }),
  templates:()          => request.get('/pm/daily-report/template'),
  createTpl:(data)      => request.post('/pm/daily-report/template', data),
  updateTpl:(id, data)  => request.put(`/pm/daily-report/template/${id}`, data),
  removeTpl:(id)        => request.delete(`/pm/daily-report/template/${id}`)
};
